import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Message } from 'semantic-ui-react';
import Icon from '../icon';
import Text from '../text';
import cls from './styles.scss';
const cx = classnames.bind(cls);
const defaultIconName = {
    info: 'info-circle',
    caution: 'exclamation-triangle',
    error: 'exclamation-circle',
    success: 'check-circle',
};
export const alertSlotsPropType = PropTypes.shape({
    action: PropTypes.node,
});
const Alert = ({ role, header, content, slots, onDismiss, className, showIcon, icon, elmId, ...restProps }) => {
    const defaultIcon = role && (_jsx(Icon, { name: defaultIconName[role], color: role, iconStyle: 'light', size: 'big' }));
    const iconElement = showIcon && (icon || defaultIcon);
    const wrappedContent = typeof content === 'string' ? (_jsx(Text, { "data-elm-id": 'content', children: content })) : (content);
    return (_jsxs(Message, { className: cx('alert', role ? `alert-${role}` : 'alert-none', className), icon: !!iconElement, "data-elm-id": elmId, onDismiss: onDismiss, ...restProps, children: [iconElement, _jsxs(Message.Content, { children: [header && _jsx(Header, { role: role, children: header }), wrappedContent] }), slots?.action && (_jsx("div", { className: cx('action-content', { dismissible: onDismiss }), children: typeof slots.action === 'function' ? slots.action?.() : slots.action }))] }));
};
Alert.propTypes = {
    icon: PropTypes.node,
    role: PropTypes.oneOf(['info', 'caution', 'error', 'success', '', undefined]),
    header: PropTypes.any,
    content: PropTypes.any,
    slots: alertSlotsPropType,
    onDismiss: PropTypes.func,
    className: PropTypes.string,
    color: PropTypes.string,
    compact: PropTypes.bool,
    size: PropTypes.any,
    hidden: PropTypes.bool,
    showIcon: PropTypes.bool,
    style: PropTypes.object,
    elmId: PropTypes.string,
};
Alert.defaultProps = {
    icon: null,
    content: null,
    slots: null,
    onDismiss: null,
    hidden: false,
    showIcon: false,
    elmId: 'alert_message',
};
const Header = ({ className, role, children }) => {
    return (_jsx(Message.Header, { className: cx('alert-header', className), "data-elm-id": 'header', children: children }));
};
Header.propTypes = {
    role: PropTypes.oneOf(['info', 'caution', 'error', 'success', '', undefined]),
    children: PropTypes.any,
    className: PropTypes.string,
};
Alert.Header = Header;
export default Alert;
//# sourceMappingURL=index.js.map